import moment from 'moment-timezone';
import {
  createEl,
} from '../../helpers/domHelpers';
import { findTimeText } from '../calendarView/calendar.js'
import { widgetCtrl as ctrl } from '../../widgetController';
import styles from '../../css/appointmentView.css';

function makeAppointment(booking, location) {
  const datetime = moment.tz(booking.start_datetime, ctrl.getTz());
  const address = {
    street: location.street_address,
    full: `${location.city}, ${location.state} ${location.zip}`,
  };
  return {
    date: datetime.format('dddd, MMMM D YYYY'),
    time: datetime.format('h:mm A'),
    location: {
      name: location.name,
      address,
    },
  };
}

const findTimeRange = (startDateTime) => {
  const timeString = moment.tz(startDateTime, ctrl.getTz()).format('h:mm A');
  if (timeString === '9:30 AM') { return '9:30 AM – 12:00 PM'; }
  if (timeString === '12:00 PM') { return '12:00 PM – 2:30 PM'; }
  if (timeString === '2:30 PM') { return '2:30 PM – Closing'; }
  return `${timeString} – 9:30 PM`;
};

const infoTables = {
  booking: {
    render() {
      const appointment = makeAppointment(ctrl.getAppointmentInfo(), ctrl.getCurrentLocation());
      const bookingInfoFragment = document.createDocumentFragment();

      this.locationElem = createEl('div', styles.bookingValue);
      this.dateElem = this.locationElem.cloneNode();
      this.timeElem = this.locationElem.cloneNode();
      this.timeRangeElem = this.locationElem.cloneNode();

      const labelRow = createEl('div', styles.appointmentDetails, 'Appointment Details:')
      const locationRow = createEl('div', styles.bookingRow);
      this.locationElem.append(
      createEl('span', styles.bookingValueLine, appointment.location.name),
      createEl('span', styles.bookingValueLine, appointment.location.address.street),
      createEl('span', styles.bookingValueLine, appointment.location.address.full),
    );
      locationRow.append(
      createEl('div', styles.bookingLabel, 'location'),
      this.locationElem,
    );
      const dateRow = createEl('div', styles.bookingRow);
      this.dateElem.append(createEl('span', styles.bookingValueLine, appointment.date));
      dateRow.append(
      createEl('div', styles.bookingLabel, 'date'),
      this.dateElem,
    );
      const booking = ctrl.getAppointmentInfo();
      const timeText = findTimeText(booking.automation, booking.start_datetime);

      this.timeElem.append(createEl('span', styles.bookingValueLine, timeText));
      const timeRow = createEl('div', styles.bookingRow);
      timeRow.append(
        createEl('div', styles.bookingLabel, 'time'),
        this.timeElem,
      );

      let message;
      let timeRangeRow;
      if (booking.automation) {
        message = createEl('div', 'openchair-message-section');
        const autoMessage = createEl('p', styles.automationMessage, 'Please fill out your contact information. We will use this to send you a confirmation email with an appointment time within your selected range.');
        message.append(
          createEl('h2', styles.automationH2, `Thank you for selecting an appointment window at ${appointment.location.name}.`),
          autoMessage,
        );

        this.timeRangeElem.append(createEl('span', styles.bookingValueLine, findTimeRange(booking.start_datetime)))
        timeRangeRow = createEl('div', styles.bookingRow);
        timeRangeRow.append(
          createEl('div', styles.bookingLabel, 'time range'),
          this.timeRangeElem
        );
      } else {
        message = '';
        timeRangeRow = '';
      }


      bookingInfoFragment.append(
        message,
        labelRow,
        locationRow,
        dateRow,
        timeRow,
        timeRangeRow,
      );
      return bookingInfoFragment;
    },
  },
  patient: {
    render() {
      const patient = ctrl.getPatientInfo();
      const fragment = document.createDocumentFragment();
      Object.keys(patient).forEach((key) => {
        const row = createEl('div', styles.patientRow);
        if (key === 'message') {
          row.append(
          createEl('div', styles.patientLabel, key),
          createEl('div', styles.patientValueMessage, patient[key]),
        );
        } else {
          row.append(
          createEl('div', styles.patientLabel, key),
          createEl('div', styles.patientValue, patient[key]),
        );
        }
        fragment.append(row);
      });

      return fragment;
    },
  },
};

export default infoTables;



// WEBPACK FOOTER //
// ./src/views/appointmentView/infoTables.js